/*
  "Curated by KNAKRD" row (PDP LAB 19 Sep 2026). Markup: sections/kn-curated.liquid.
  Cards, in order: this piece in each of its other colours (colour picked on the page is left
  out), then up to four other pieces in the chosen colour, the other half of the outfit first.
  Follows the page's colour through the ?variant= URL, which every product page updates.
*/
(() => {
  if (customElements.get('kn-curated')) return;
  const group = (type) => {
    const t = (type || '').toLowerCase();
    if (/bra|top|jacket|tee|shirt|hood/.test(t)) return 'top';
    if (/legging|short|pant/.test(t)) return 'bottom';
    return 'full';
  };
  if (!window.__knUrlPatched) {
    window.__knUrlPatched = true;
    const orig = history.replaceState;
    history.replaceState = function (...args) {
      const r = orig.apply(this, args);
      window.dispatchEvent(new Event('kn:url'));
      return r;
    };
  }

  class KnCurated extends HTMLElement {
    connectedCallback() {
      this.self = JSON.parse(this.querySelector('[data-kcu-self]').textContent);
      this.pool = JSON.parse(this.querySelector('[data-kcu-pool]').textContent);
      this.row = this.querySelector('[data-kcu-row]');
      this.handle = this.dataset.product;
      this.mine = group(this.dataset.type);
      window.addEventListener('kn:url', () => this.sync());
      const step = () => this.row.clientWidth * 0.8;
      this.querySelector('[data-kcu-prev]').addEventListener('click', () => this.row.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.querySelector('[data-kcu-next]').addEventListener('click', () => this.row.scrollBy({ left: step(), behavior: 'smooth' }));
      this.colour = this.currentColour();
      this.render();
    }

    currentColour() {
      const id = new URLSearchParams(location.search).get('variant');
      return this.self[id] || Object.values(this.self)[0];
    }

    sync() {
      const c = this.currentColour();
      if (c && c !== this.colour) { this.colour = c; this.render(); }
    }

    items() {
      const own = this.pool.filter((it) => it.handle === this.handle && it.colour !== this.colour)
        .sort((a, b) => (a.available ? 0 : 1) - (b.available ? 0 : 1));
      const opposite = this.mine === 'top' ? 'bottom' : this.mine === 'bottom' ? 'top' : null;
      const seen = new Set();
      const look = this.pool
        .filter((it) => it.handle !== this.handle && it.colour === this.colour)
        .sort((a, b) => ((a.available ? 0 : 5) + (opposite && group(a.type) === opposite ? 0 : 2)) - ((b.available ? 0 : 5) + (opposite && group(b.type) === opposite ? 0 : 2)))
        .filter((it) => (seen.has(it.handle) ? false : seen.add(it.handle)))
        .slice(0, 4);
      return [...own.map((it) => ({ ...it, kind: 'colour' })), ...look.map((it) => ({ ...it, kind: 'look' }))];
    }

    render() {
      const list = this.items();
      this.hidden = !list.length;
      this.row.textContent = '';
      list.forEach((it, i) => {
        const li = document.createElement('li');
        li.className = 'kcu__item';
        li.style.setProperty('--i', i);
        li.innerHTML = '<a class="kcu__card"><span class="kcu__img"><img loading="lazy" decoding="async" width="600" height="800" alt=""></span><span class="kcu__name"></span><span class="kcu__colour"></span><span class="kcu__price"></span></a>';
        li.querySelector('a').href = it.url;
        const img = li.querySelector('img');
        img.src = it.img;
        img.alt = `${it.title} in ${it.colour}`;
        li.querySelector('.kcu__name').textContent = it.title;
        li.querySelector('.kcu__colour').textContent = it.colour + (it.available ? '' : ' · sold out');
        li.querySelector('.kcu__price').textContent = it.price;
        this.row.appendChild(li);
      });
      this.row.scrollTo({ left: 0 });
    }
  }
  customElements.define('kn-curated', KnCurated);
})();

/* "You may also like" arrows (PDP LAB 20 Sep 2026). Lives here because Dawn re-renders that
   section from a fetch, and scripts inside injected HTML never run. */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-kn-rel-prev], [data-kn-rel-next]');
  if (!b) return;
  const row = b.closest('product-recommendations')?.querySelector('.kn-swipe-row');
  if (!row) return;
  row.scrollBy({ left: (b.hasAttribute('data-kn-rel-prev') ? -1 : 1) * row.clientWidth * 0.8, behavior: 'smooth' });
});
